/**
 * CSV-export för Enhetsköer (svensk Excel: semikolon + BOM).
 */

export interface DeviceQueueCsvRow {
  phase: string;
  registrationNumber: string;
  makeModel: string;
  groupName: string;
  imei: string;
  lastSeen: string;
}

export function escapeCsvField(value: string): string {
  const normalized = value.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  if (/[;"\n]/.test(normalized)) {
    return `"${normalized.replace(/"/g, '""')}"`;
  }
  return normalized;
}

/** Excel ska inte tolka 15-siffriga IMEI som tal (förlorar precision). */
export function escapeCsvImei(imei: string): string {
  const digits = imei.trim();
  if (!digits) return '';
  return `"=""${digits.replace(/"/g, '""')}"""`;
}

export function buildDeviceQueueCsv(headers: string[], rows: DeviceQueueCsvRow[]): string {
  const headerLine = headers.map(escapeCsvField).join(';');
  const dataLines = rows.map((row) =>
    [
      escapeCsvField(row.phase),
      escapeCsvField(row.registrationNumber),
      escapeCsvField(row.makeModel),
      escapeCsvField(row.groupName),
      escapeCsvImei(row.imei),
      escapeCsvField(row.lastSeen),
    ].join(';'),
  );
  return [headerLine, ...dataLines].join('\r\n');
}

export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function deviceQueueCsvFilename(view: 'queue' | 'done', now = new Date()): string {
  const stamp = now.toISOString().slice(0, 10);
  const suffix = view === 'done' ? 'klara' : 'i-ko';
  return `enhetskoer-${suffix}-${stamp}.csv`;
}
